import React from 'react';
import { useSelector } from 'react-redux';
import { StoreState } from '../../types/store.type';
import { Modal } from 'react-bootstrap';
import { ImageSecurityAlert } from '../../assets/images';
import { ValidationUtils, AuthUtils, TranslationUtils } from '../../utils';

import './SessionExpiredModal.scss';

export const SessionExpiredModal: React.FC = () => {
    const { isSessionExpired: show } = useSelector((store: StoreState) => store.user);
    const myTripsLoginUrl = `${ValidationUtils.validateAndGetEnvVar('REACT_APP_VACASA_URI')}/login?mode=my_trips&path=/my-trips`;
    const handleClose = () => {
        AuthUtils.redirectOnSessionExpired();
    };

    const blurEverything = () => {
        const app = document.getElementById('routed-app');
        if (app) {
            app.setAttribute('class', 'blur');
        }
    };

    return (
        <Modal id="user-modal" show={show} onHide={handleClose} onEnter={blurEverything}>
            <Modal.Header closeButton />

            <div className="user-modal-body">
                <div>
                    <ImageSecurityAlert className="user-modal-image" />
                </div>
                <h4 className={'heading-med-light'}>{TranslationUtils.get('session_expired')}</h4>

                <div className="user-modal-instructions">
                    <p className={'body-regular'}>
                        {TranslationUtils.get('session_expired_message')} <a href={myTripsLoginUrl}>{TranslationUtils.get('my_trips')}</a>
                    </p>
                </div>
            </div>
        </Modal>
    );
};
